import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async saveForm(event)
		{
			try{

				//antes de guardar
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'actualizarFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'send_backend', 
									tablaPost: ['datos_basicos']
								}
							}) 
						break;

					}
				}

				//guardar
				await this.save(event.save)

				//despues de guardar
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'actualizarFtn':

						break;

					}
				}

				
				this.resetGlobal({state: 'indexData'})
				this.resetGlobal({state: 'openModal'})
				this.resetDataForm()
				
				return true
			}
			catch{

			}			
		}		
	},
}
